import type { Key } from './en';

/** Urdu (RTL, Noto Nastaliq Urdu). Product names, amounts and ids stay in Latin script with Western digits.
 *  Native-speaker review pending. */
export const ur: Partial<Record<Key, string>> = {
  'nav.main': 'مرکزی مینو',
  'nav.home': 'ہوم',
  'nav.home.overview': 'جائزہ',
  'nav.home.today': 'آج سائٹ پر',
  'nav.home.weekly': 'ہفتہ وار رپورٹ',
  'nav.projects': 'پروجیکٹس',
  'nav.projects.all': 'تمام پروجیکٹس',
  'nav.projects.stages': 'مراحل اور پیش رفت',
  'nav.projects.timeline': 'ٹائم لائن',
  'nav.projects.files': 'نقشے اور فائلیں',
  'nav.projects.diary': 'سائٹ ڈائری',
  'nav.projects.photos': 'تصاویر',
  'nav.office': 'سائٹ آفس',
  'nav.office.attendance': 'حاضری',
  'nav.office.wages': 'اجرت شیٹ',
  'nav.office.workers': 'مزدور اور ٹیمیں',
  'nav.office.todos': 'کرنے کے کام',
  'nav.office.visitors': 'مہمان',
  'nav.stores': 'اسٹور',
  'nav.stores.stock': 'سائٹ پر اسٹاک',
  'nav.stores.receive': 'مال وصولی',
  'nav.stores.issue': 'کام کے لیے اجرا',
  'nav.stores.transfers': 'منتقلی',
  'nav.stores.water': 'پانی کے ٹینکر',
  'nav.stores.debris': 'ملبے کے ٹرک',
  'nav.buy': 'خریداری',
  'nav.buy.requests': 'درخواستیں',
  'nav.buy.quotations': 'کوٹیشنز',
  'nav.buy.orders': 'پرچیز آرڈرز',
  'nav.buy.suppliers': 'سپلائرز',
  'nav.money': 'رقم',
  'nav.money.budget': 'بجٹ اور تخمینہ',
  'nav.money.changes': 'تبدیلی کے آرڈر',
  'nav.money.invoices': 'کلائنٹ انوائس',
  'nav.money.bills': 'بل',
  'nav.money.petty': 'پیٹی کیش',
  'nav.money.payments': 'ادائیگیاں',
  'nav.money.tax': 'ٹیکس',
  'nav.clients': 'کلائنٹس',
  'nav.clients.links': 'کلائنٹ لنک',
  'nav.clients.selections': 'انتخاب',
  'nav.clients.enquiries': 'پوچھ گچھ',
  'nav.reports': 'رپورٹس',
  'nav.reports.progress': 'پیش رفت',
  'nav.reports.cost': 'بجٹ کے مقابلے میں خرچ',
  'nav.reports.stock': 'اسٹاک اور پانی',
  'nav.reports.attendance': 'حاضری اور اجرت',
  'nav.reports.export': 'ایکسپورٹ',
  'nav.settings': 'سیٹنگز',
  'nav.settings.company': 'کمپنی اور سائٹس',
  'nav.settings.people': 'افراد اور کردار',
  'nav.settings.templates': 'ٹیمپلیٹ اور ریٹس',
  'nav.settings.plan': 'پلان اور بلنگ',
  'nav.settings.export': 'میرا ڈیٹا ایکسپورٹ',
  'nav.approvals': 'منظوریاں',
  'nav.later': 'بعد میں',
  'nav.by': 'Buildiary از SMH Global Services',
  'nav.openMenu': 'مینو کھولیں',
  'nav.closeMenu': 'مینو بند کریں',
  'nav.collapse': 'مینو چھوٹا کریں',
  'nav.expand': 'مینو بڑا کریں',
  'nav.breadcrumb': 'راستہ',
  'nav.skip': 'مواد پر جائیں',
  'nav.home.link': 'Buildiary ہوم',

  'top.search': 'تلاش کریں یا جائیں…',
  'top.project': 'پروجیکٹ',
  'top.projects': 'پروجیکٹس',
  'top.allProjects': 'تمام {n} پروجیکٹس',
  'top.siteDate': 'سائٹ کی تاریخ',
  'top.approvals': 'منظوریاں، {n} منتظر',
  'top.notifications': 'اطلاعات، {n} نئی',
  'top.notesTitle': 'اطلاعات',
  'top.noNotes': 'آج کوئی نئی بات نہیں۔',
  'top.language': 'زبان',
  'top.account': 'اکاؤنٹ',
  'top.signOut': 'سائن آؤٹ',
  'top.changePin': 'اپنا PIN بدلیں',
  'top.gateMode': 'گیٹ موڈ (ٹیبلٹ)',
  'top.feedback': 'رائے بھیجیں',
  'top.switchProject': 'پروجیکٹ بدلیں',
  'top.demo': 'ڈیمو ورک اسپیس',

  'pal.title': 'تلاش کریں یا جائیں',
  'pal.placeholder': 'صفحہ، مزدور، آئٹم، سپلائر یا نمبر لکھیں…',
  'pal.goTo': 'جائیں',
  'pal.found': 'ملا',
  'pal.none': 'کچھ نہیں ملا۔',
  'pal.searching': 'تلاش ہو رہی ہے…',
  'pal.navigate': 'اوپر نیچے',
  'pal.select': 'کھولیں',

  'si.kicker': 'ڈیمو ورک اسپیس',
  'si.kickerLive': 'تعمیراتی سائٹ کا انتظام',
  'si.headline': 'آپ کی تعمیراتی سائٹ، آپ کے فون پر۔',
  'si.promise': 'ہر اندراج پر تصویر، نام اور وقت، تاکہ مالک اور بلڈر ایک ہی حقائق دیکھیں۔',
  'si.f1': 'گیٹ پر سائٹ کارڈ یا PIN سے حاضری',
  'si.f2': 'اسٹور، پانی کے ٹینکر اور ملبے کے ٹرک، ہر ایک تصویر کے ساتھ',
  'si.f3': 'مالک کے لیے انگریزی، اردو یا عربی میں ہفتہ وار رپورٹ',
  'si.endorse': 'SMH Global کی ایک پروڈکٹ',
  'si.title': 'سائن اِن',
  'si.lead': 'اپنی دفتری ای میل استعمال کریں، یا ڈیمو دیکھنے کے لیے نیچے کوئی فرد چنیں۔',
  'si.leadLive': 'اپنی دفتری ای میل یا فون اور پاس ورڈ استعمال کریں۔',
  'si.email': 'ای میل یا فون',
  'si.password': 'پاس ورڈ',
  'si.passwordDemo': 'ڈیمو میں ضرورت نہیں',
  'si.continueAs': '{name} کے طور پر جاری رکھیں',
  'si.signIn': 'سائن اِن',
  'si.or': 'یا ڈیمو آزمائیں بطور',
  'si.demoNote': 'ڈیمو میں نمونے کی سائٹس ہیں اور سب کچھ اسی براؤزر میں رہتا ہے۔ اپنی ورک اسپیس شروع کرنے کے لیے جائیں',
  'si.staff': 'سائٹ اسٹاف: کارڈ یا PIN سے سائن اِن کریں',
  'si.staffTitle': 'سائٹ کارڈ یا PIN سے سائن اِن',
  'si.staffLead': 'اپنے سائٹ کارڈ کا نمبر یا فون نمبر لکھیں، پھر اپنا PIN۔',
  'si.workspace': 'ورک اسپیس',
  'si.card': 'کارڈ نمبر یا فون',
  'si.pin': 'PIN',
  'si.emailRequired': 'اپنی ای میل یا فون لکھیں۔',
  'si.passwordRequired': 'اپنا پاس ورڈ لکھیں۔',
  'si.pinRequired': 'اپنا 4 سے 6 ہندسوں کا PIN لکھیں۔',
  'si.cardRequired': 'اپنا کارڈ نمبر یا فون لکھیں۔',
  'si.failed': 'یہ کام نہیں ہوا۔ تفصیل دیکھ کر دوبارہ کوشش کریں۔',
  'si.signingIn': 'سائن اِن ہو رہا ہے…',
  'persona.owner': 'ہوم، ہفتہ وار رپورٹ کے ساتھ',
  'persona.ownersup': 'منظوریاں اور سائٹ کے دورے',
  'persona.supervisor': 'آج: حاضری اور ڈائری',
  'persona.store': 'اسٹور: وصولی اور اجرا',
  'persona.accounts': 'رقم: بل اور ادائیگیاں',
  'persona.partner': 'صرف اپنے کلائنٹ کے پروجیکٹس',
  'role.partnerShort': 'بلڈر (پارٹنر)',

  'c.save': 'محفوظ کریں',
  'c.cancel': 'منسوخ',
  'c.close': 'بند کریں',
  'c.add': 'شامل کریں',
  'c.edit': 'ترمیم',
  'c.delete': 'حذف کریں',
  'c.back': 'واپس',
  'c.next': 'آگے',
  'c.done': 'ہو گیا',
  'c.approve': 'منظور کریں',
  'c.decline': 'مسترد کریں',
  'c.send': 'بھیجیں',
  'c.retry': 'دوبارہ کوشش کریں',
  'c.loading': 'لوڈ ہو رہا ہے…',
  'c.error': 'کچھ غلط ہو گیا۔',
  'c.empty': 'ابھی یہاں کچھ نہیں۔',
  'c.search': 'تلاش',
  'c.all': 'سب',
  'c.export': 'ایکسپورٹ',
  'c.download': 'ڈاؤن لوڈ',
  'c.copy': 'لنک کاپی کریں',
  'c.copied': 'کاپی ہو گیا',
  'c.share': 'شیئر کریں',
  'c.whatsapp': 'واٹس ایپ پر بھیجیں',
  'c.open': 'کھولیں',
  'c.saved': 'محفوظ ہو گیا',
  'c.photo': 'تصویر',
  'c.addPhoto': 'تصویر شامل کریں',
  'c.today': 'آج',
  'c.later': 'بعد میں',
  'c.laterNote': 'یہ بعد کی ریلیز میں آئے گا۔ ابھی یہاں کچھ کرنے کو نہیں۔',
  'c.required': 'ضروری',
  'c.offline': 'آف لائن: اس ڈیوائس پر محفوظ، انٹرنیٹ آنے پر بھیج دیا جائے گا',
  'c.print': 'پرنٹ',
  'c.undo': 'واپس لیں',
  'c.optional': 'اختیاری',
  'c.uploading': 'اپ لوڈ ہو رہا ہے…',
  'c.noAccess': 'آپ کو اس صفحے تک رسائی نہیں۔',
  'c.notFound': 'صفحہ نہیں ملا۔',
  'c.goHome': 'شروع کے صفحے پر جائیں',

  'm.today': 'آج',
  'm.scan': 'اسکین',
  'm.add': 'شامل کریں',
  'm.inbox': 'ان باکس',
  'm.more': 'مزید',
  'm.morning': 'صبح بخیر، {name}',
  'm.afternoon': 'سلام، {name}',
  'm.evening': 'شام بخیر، {name}',
  'm.allSent': 'سب بھیج دیا',
  'm.onSite': 'سائٹ پر',
  'm.notYet': '{n} ابھی نہیں آئے',
  'm.waterTank': 'پانی کی ٹنکی',
  'm.tankRead': '{time} پر پڑھا',
  'm.noTank': 'ابھی کوئی ریڈنگ نہیں',
  'm.deliveries': 'ڈیلیوریز',
  'm.deliveriesSub': 'آج {n} وصول ہوئیں',
  'm.lowStock': 'کم اسٹاک',
  'm.lowSub': '{item}: {qty} باقی',
  'm.doNext': 'اگلا کام',
  'm.scanCard': 'کارڈ اسکین',
  'm.receive': 'وصولی',
  'm.voiceNote': 'آواز کا نوٹ',
  'm.nothingNext': 'کچھ منتظر نہیں۔ شاباش۔',
  'm.markNotIn': 'جو {n} نہیں آئے انہیں درج کریں',
  'm.markNotInSub': 'دیر، غیر حاضر یا چھٹی · 09:00 سے پہلے',
  'm.due': 'آخری تاریخ {date}',
  'm.addTitle': 'سائٹ ریکارڈ میں شامل کریں',
  'add.receive': 'ڈیلیوری وصول کریں',
  'add.issue': 'کام کے لیے اجرا',
  'add.water': 'پانی کا ٹینکر',
  'add.debris': 'ملبے کا ٹرک',
  'add.diary': 'ڈائری نوٹ، آواز سے',
  'add.photo': 'پیش رفت کی تصویر',
  'add.bill': 'بل یا رسید',
  'add.petty': 'پیٹی کیش',

  'scan.title': 'سائٹ کارڈ اسکین کریں',
  'scan.gate': '{project} · گیٹ',
  'scan.in': 'اندر',
  'scan.out': 'باہر',
  'scan.comingIn': 'اندر آ رہے ہیں',
  'scan.goingOut': 'باہر جا رہے ہیں',
  'scan.hold': 'کارڈ کو فریم کے اندر رکھیں',
  'scan.holdOut': 'باہر جانا: سائٹ کارڈ کو فریم کے اندر رکھیں',
  'scan.faceNote': 'کیمرہ ریکارڈ کے لیے چہرے کی تصویر بھی لیتا ہے',
  'scan.usePin': 'PIN استعمال کریں',
  'scan.noCard': 'کارڈ نہیں؟ PIN استعمال کریں',
  'scan.torch': 'ٹارچ',
  'scan.typeCode': 'کارڈ نمبر لکھیں',
  'scan.onSite': 'GPS کے مطابق سائٹ پر',
  'scan.offSite': 'GPS سائٹ پر نہیں',
  'scan.noGps': 'GPS نہیں',
  'scan.photoSaved': 'تصویر محفوظ',
  'scan.noPhoto': 'تصویر نہیں',
  'scan.day': 'اس مہینے کا دن {n}',
  'scan.next': 'اگلا کارڈ',
  'scan.noCamera': 'کیمرہ دستیاب نہیں۔ کارڈ نمبر لکھیں یا PIN استعمال کریں۔',
  'scan.cardNo': 'کارڈ نمبر',
  'scan.worker': 'مزدور',
  'scan.pinTitle': 'PIN سے اندر یا باہر',
  'scan.record': 'درج کریں',
  'scan.undone': 'ہٹا دیا گیا۔ تیار ہوں تو دوبارہ اسکین کریں۔',
  'scan.close': 'بند کریں',
  'scan.waiting': 'کارڈ کا انتظار',

  'recv.title': 'ڈیلیوری وصول کریں',
  'recv.step1': 'مرحلہ 1 از 2 · ڈیلیوری نوٹ',
  'recv.step2': 'مرحلہ 2 از 2 · جو آیا اسے چیک کریں',
  'recv.notePhoto': 'ڈیلیوری نوٹ کی تصویر',
  'recv.takeNote': 'ڈیلیوری نوٹ کی تصویر لیں',
  'recv.supplier': 'سپلائر',
  'recv.noteNo': 'ڈیلیوری نوٹ نمبر',
  'recv.order': 'پرچیز آرڈر',
  'recv.noOrder': 'آرڈر کے بغیر آیا',
  'recv.matched': 'آرڈر {order} سے ملایا گیا',
  'recv.what': 'کیا آیا',
  'recv.ordered': 'آرڈر {q}',
  'recv.short': '{n} {unit} کم: سپلائر کو بتا دیا گیا، بل چیک ہوگا',
  'recv.goods': 'سامان کی تصویر',
  'recv.draft': 'ڈرافٹ محفوظ کریں',
  'recv.addStock': 'اسٹاک میں شامل کریں',
  'recv.addLine': 'آئٹم شامل کریں',
  'recv.item': 'آئٹم',
  'recv.qty': 'وصول شدہ مقدار',
  'recv.less': 'کم',
  'recv.more': 'زیادہ',
  'recv.noteRequired': 'آپ کی ورک اسپیس کے اصول کے مطابق ڈیلیوری نوٹ کی تصویر ضروری ہے۔',
  'recv.goodsRequired': 'آپ کی ورک اسپیس کے اصول کے مطابق سامان کی تصویر ضروری ہے۔',
  'recv.noLines': 'کم از کم ایک آئٹم مقدار کے ساتھ شامل کریں۔',
  'recv.done': 'اسٹاک میں شامل: {n} لائنیں۔',
  'recv.draftSaved': 'ڈرافٹ اس ڈیوائس پر محفوظ ہو گیا۔',
  'recv.by': '{name} · {time}',

  'lang.en': 'انگریزی',
  'lang.ur': 'اردو',
  'lang.ar': 'عربی',
  'diary.title': 'سائٹ ڈائری',
  'diary.voice': 'آواز کا نوٹ · {name}',
  'diary.note': 'نوٹ · {name}',
  'diary.photos': 'پیش رفت کی {n} تصاویر · {name}',
  'diary.ai': '{lang} سے AI نے لکھا · چیک کر لیں',
  'diary.hold': 'بولنے کے لیے دبائے رکھیں',
  'diary.recording': 'ریکارڈنگ… چھوڑیں تو بھیج دیا جائے گا',
  'diary.tapMode': 'شروع کرنے کے لیے دبائیں، بھیجنے کے لیے دوبارہ دبائیں',
  'diary.type': 'یا نوٹ لکھیں…',
  'diary.send': 'نوٹ بھیجیں',
  'diary.play': 'آواز کا نوٹ چلائیں',
  'diary.pause': 'روکیں',
  'diary.mic': 'مائیکروفون بند ہے۔ براؤزر میں اجازت دیں، یا نوٹ لکھیں۔',
  'diary.saved': 'ڈائری میں شامل ہو گیا۔',
  'diary.empty': 'اس دن ابھی کوئی اندراج نہیں۔',
  'diary.uploading': 'آواز کا نوٹ بھیجا جا رہا ہے…',
  'diary.short': 'بہت مختصر: بولتے وقت بٹن دبائے رکھیں۔',

  'owner.house': 'آپ کا گھر',
  'owner.week': '{week}',
  'owner.handover': '{date} کو حوالگی، منصوبے کے مطابق',
  'owner.from': 'اس ہفتے {name} کی طرف سے',
  'owner.spent': 'اس ہفتے کا خرچ',
  'owner.under': 'منصوبے سے {amt} کم',
  'owner.over': 'منصوبے سے {amt} زیادہ',
  'owner.nextPay': 'اگلی ادائیگی',
  'owner.stageDue': 'مرحلہ {n} · واجب {date}',
  'owner.nothingDue': 'کچھ واجب نہیں',
  'owner.needsYes': 'آپ کی منظوری درکار',
  'owner.ask': '{name} سے پوچھیں',
  'owner.more': 'ایک اور: {title}، {amt}',
  'owner.days': '{n} دن مزید',
  'owner.noDays': 'تکمیل کی تاریخ میں تبدیلی نہیں',
  'owner.built': '{n} فیصد تعمیر',
  'owner.photos': 'تصاویر',
  'owner.invoices': 'انوائس اور مرحلہ وار ادائیگیاں',
  'owner.changes': 'تبدیلی کے آرڈر',
  'owner.paid': 'ادا شدہ',
  'owner.due': 'واجب {date}',
  'owner.notYet': 'ابھی نہیں',
  'owner.approved': 'منظور',
  'owner.declined': 'مسترد',
  'owner.waiting': 'آپ کا انتظار',
  'owner.note': 'بلڈر کے لیے نوٹ',
  'owner.confirmApprove': '{number} کو {amt} میں منظور کریں؟',
  'owner.confirmDecline': '{number} مسترد کریں؟',
  'owner.thanks': 'شکریہ۔ آپ کا جواب بلڈر کو بھیج دیا گیا۔',
  'owner.noUpdate': 'ہفتہ وار رپورٹ ابھی تیار نہیں۔',
  'owner.allDone': 'کچھ بھی آپ کے جواب کا منتظر نہیں۔',
  'client.shared': '{workspace} نے Buildiary کے ذریعے شیئر کیا',
  'client.private': 'سائن اِن کی ضرورت نہیں۔ یہ لنک صرف آپ کے لیے ہے؛ براہ کرم آگے نہ بھیجیں۔',
  'client.bad': 'یہ لنک ختم ہو چکا ہے یا درست نہیں۔ اپنے بلڈر سے نیا لنک مانگیں۔',
  'client.stage': 'اب: {stage}',
  'client.progress': 'پیش رفت',
  'client.total': 'کل',
  'client.amount': 'رقم',
  'client.lines': 'کیا بدلے گا',
  'supplier.title': '{name} کا اسٹیٹمنٹ',
  'supplier.orders': 'آرڈرز',
  'supplier.bills': 'بل',
  'supplier.payments': 'ادائیگیاں',
  'supplier.balance': 'آپ کا واجب الادا بقایا',
  'supplier.from': '{workspace} کی طرف سے',

  'wk.title': 'مالک کے لیے ہفتہ وار رپورٹ',
  'wk.draftedAi': 'AI نے تیار کی · بھیجنے سے پہلے آپ چیک کریں',
  'wk.draftedTemplate': 'ٹیمپلیٹ سے تیار · بھیجنے سے پہلے آپ چیک کریں',
  'wk.sends': '{when} کو واٹس ایپ اور ای میل سے جائے گی',
  'wk.checkSend': 'چیک کر کے بھیجیں',
  'wk.sent': '{when} کو بھیجی گئی',
  'owner.sentOn': '{when} کو بھیجی گئی',
  'si.at': '{name} میں سائن ان کریں',
  'si.notYou': 'یہ آپ کا ورک اسپیس نہیں؟',
  'si.find': 'میرا ورک اسپیس تلاش کریں',
  'si.start': 'مفت آزمائش شروع کریں',
  'nows.title': 'اس پتے پر کوئی ورک اسپیس نہیں',
  'nows.text': 'پتے میں نام چیک کریں، مثلاً alnoor.buildiary.app۔ اگر بھول گئے ہیں تو ہم آپ کو ای میل کر سکتے ہیں۔',
  'nows.site': 'بلڈائری کے بارے میں',
  'my.title': 'آپ کی تعمیراتی سائٹ، آپ کے فون پر۔',
  'my.lead': 'مفت آزمائش شروع کریں، یا اپنے ورک اسپیس کا پتہ تلاش کریں۔',
  'my.go': 'اپنے ورک اسپیس پر جائیں',
  'my.goHint': 'اپنے ورک اسپیس کا نام لکھیں',
  'my.console': 'ایس ایم ایچ گلوبل ٹیم: کنسول',
  'find.title': 'میرا ورک اسپیس تلاش کریں',
  'find.lead': 'وہ ای میل لکھیں جس سے آپ سائن ان کرتے ہیں۔ ہم آپ کے ہر ورک اسپیس کا پتہ اسی ای میل پر بھیج دیں گے۔',
  'find.email': 'آپ کی ای میل',
  'find.send': 'مجھے لنک ای میل کریں',
  'st.title': 'اپنی مفت آزمائش شروع کریں',
  'st.lead': '{days} دن مفت۔ نہ کارڈ، نہ خودکار کٹوتی: جاری رکھنے کا فیصلہ کریں تب ہی بینک ٹرانسفر سے ادائیگی کریں۔',
  'st.what': 'آپ کیا بنا رہے ہیں؟',
  'st.owner': 'اپنا گھر',
  'st.builder': 'کلائنٹس کے پروجیکٹ',
  'st.perMonth': '{price} ماہانہ',
  'st.perYear': 'یا {price} سالانہ',
  'st.limits': '{projects} پروجیکٹ · {users} افراد',
  'st.data': 'آپ کیسے شروع کرنا چاہتے ہیں؟',
  'st.empty': 'خالی، اپنے پروجیکٹ کے ساتھ',
  'st.sample': 'اپنے ملک کے نمونہ ڈیٹا کے ساتھ',
  'st.name': 'آپ کا نام',
  'st.email': 'ای میل',
  'st.country': 'ملک',
  'st.phone': 'موبائل (واٹس ایپ)',
  'st.company': 'ورک اسپیس کا نام',
  'st.companyHint': 'آپ کی کمپنی، یا وہ گھر جو آپ بنا رہے ہیں',
  'st.address': 'پتہ',
  'st.free': 'دستیاب',
  'st.agree': 'میں شرائط اور رازداری کی پالیسی قبول کرتا/کرتی ہوں',
  'st.terms': 'شرائط',
  'st.go': 'میری مفت آزمائش شروع کریں',
  'st.checkTitle': 'اپنی ای میل دیکھیں',
  'st.checkLead': 'ہم نے {email} پر 6 ہندسوں کا کوڈ بھیجا ہے۔ اسے یہاں لکھیں، یا ای میل میں دیا گیا لنک کھولیں۔',
  'st.mailOff': 'ہماری ٹیم جلد آپ کو کوڈ بھیج دے گی (ای میل یا واٹس ایپ پر)۔',
  'st.code': 'کوڈ',
  'st.confirm': 'تصدیق کریں اور ورک اسپیس کھولیں',
  'st.resend': 'نیا کوڈ بھیجیں',
  'st.resent': 'نیا کوڈ بھیج دیا گیا ہے۔',
  'st.opening': 'آپ کا ورک اسپیس تیار ہے۔ کھول رہے ہیں…',
  'st.ready': 'آپ کا ورک اسپیس تیار ہے',
  'st.openIt': '{host} کھولیں',
  'st.closed': 'نئے سائن اپ فی الحال بند ہیں۔ براہ کرم ہم سے رابطہ کریں۔',
  'st.have': 'پہلے سے ورک اسپیس ہے؟',
  'plan.trialLeft': 'مفت آزمائش: {n} دن باقی۔',
  'plan.trialLast': 'مفت آزمائش: آج آخری دن ہے۔',
  'plan.paidLeft': 'آپ کا پلان {n} دن میں ختم ہو گا۔',
  'plan.ended': 'آپ کی مفت آزمائش ختم ہو گئی ہے۔ سب کچھ محفوظ ہے اور دیکھا جا سکتا ہے؛ پلان کی ادائیگی تک نیا اندراج نہیں ہو سکتا۔',
  'plan.endedPaid': 'آپ کا پلان ختم ہو گیا ہے۔ سب کچھ محفوظ ہے اور دیکھا جا سکتا ہے؛ تجدید تک نیا اندراج نہیں ہو سکتا۔',
  'plan.pay': 'پلان اور ادائیگی',
  'plan.askOwner': 'مالک سے تجدید کے لیے کہیں۔',
  'top.changeWorkspace': 'ورک اسپیس بدلیں',
  'scan.native': 'کارڈ اسکین کریں',
};
